<template>
	<div class="knd-multiple-choice">
		<div class="knd-paragraaf">

      <h3>Kies het juiste antwoord</h3>

      <slot name="media"></slot>
      <slot name="video"></slot>


      <blockquote class="knd-quote">
        {{data.uitspraak}}       
         <footer> {{data.bron}}</footer>
      </blockquote>

      <div class="knd-vraag">
        {{ question.vraag }}
      </div>

      <div class="multiple-options">
        <div 
          v-for="(optie, index) in question.opties" 
          class="multiple-option" 
          :class="[answer.answered ? optie.antwoord ? 'correct' : 'incorrect' : '']"
          :key="'optie' + index">
            <input 
              type="radio" 
              :id="'question-' + id +'-answer-' + index" 
              @change="onClick($event)"
              :disabled="answer.answered"
              class="input-hidden"
              :value="index" 
              :checked="answer.answered && answer.value === index"
              />
            <label 
              :for="'question-' + id +'-answer-' + index" 
              > 
              <div class="answer-letter">{{  alphabet[index] }}</div>
              <div>{{optie.optie}}</div>

              <div 
                class="feedback-icon"
                :class="[answer.answered ? optie.antwoord ? 'correct' : 'incorrect' : '']"
              >

              </div>
            </label>
        </div>
      </div>

      <Uitklap 
        :collapse="answer.answered"
        :correct="answer.correct"
        :feedback="data.feedback"
      />

		</div>
	</div>
</template>

<script>
import Uitklap from '@/components/uitklap';

export default {
	name: 'App',
  props: ['data', 'question', 'answer'],
  components: { Uitklap},
	data() {
    return {
      id: this.data.id,
      alphabet: "abcdefghijklmnopqrstuvwxyz".split('')
		}
	},

  setup() {
  },

	methods: {
    onClick(event) {
      var number = +event.target.value;

      let currentQuestion = this.question.opties[number];
      let correct = currentQuestion.antwoord ? true: false;

      this.$store.dispatch('saveAnswer', 
      {
        id: this.id, 
        value: +number, 
        correct: correct,
        answered: true
      });
    }
	}
}
</script>


<style lang="scss">
.knd-multiple-choice {
  background: linear-gradient(192.17deg, #00DEB2 37.82%, #D0FFEB 96.84%);
}

.knd-vraag {
  margin-bottom: var(--knd-spacing-lg);
}

.multiple-option {
  margin-bottom: var(--knd-spacing-md);

  position: relative;


  label {
    cursor: pointer;
    padding: 1rem;
    background: $pale-pistachio;
    border-radius: 8px;
    transition: background .3s ease-in;

    &:hover {
      background: $pistachio;
    } 
  }

  .feedback-icon {
    position: absolute;
    right: -20px;
  }

  label {
    display: flex;
    align-items: center;

    .answer-letter {
      font-family: $font-header;
      flex: 0 0 35px;
      font-size: 1.8em;
      font-weight: 500;
      align-self: end;
    }
  }


 input[type="radio"]:checked+label{  
  background: $pistachio;
  } 

  input[type="radio"]:disabled+label{
      pointer-events: none;
  } 
}
</style>